import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '0.5rem',
      padding: '0.4rem 0.75rem',
    },
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#9e9e9e',
    transition: 'all 0.3s ease',
    userSelect: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
    },
  },
  activeLabel: {
    color: '#2E656A',
    fontWeight: 600,
  },
}))

